import React, { useEffect, useState } from 'react'
import { componentMap } from '@/components/QuizStep'
import { useSearchParams } from 'react-router-dom'

export const VariationStep = ({
  data,
  onValid,
  onNextStep,
}: {
  data: any
  onValid: any
  onNextStep: any
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [variant, setVariant] = useState<string | null>(null)

  const { slug, variations } = data

  useEffect(() => {
    if (!variations?.length) return

    const fromUrl = searchParams.get('variant')

    const storageKey = `variant:${slug}`
    const fromStorage =
      typeof window !== 'undefined' ? window.localStorage.getItem(storageKey) : null

    const chosen = fromUrl || fromStorage || variations[0].name
    setVariant(chosen)

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(storageKey, chosen)
    }
  }, [slug, variations, searchParams, setSearchParams])

  if (!variant) return null

  const components = variations.find((el: any) => el.name === variant)?.components ?? []

  return (
    <>
      {components?.map((dataComponent: any, index: number) => {
        const Component = componentMap[dataComponent.component]
        if (!Component) return null
        return (
          <Component
            key={dataComponent.component + '-' + index}
            data={{ version: data.version, ...dataComponent }}
            onValid={onValid}
            onNextStep={onNextStep}
          />
        )
      })}
    </>
  )
}
